import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Glyphicon,
  Grid,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap'

import Plotly from 'plotly.js/dist/plotly'
import PropTypes from 'prop-types'
import React from 'react'
import SaxsHPLCPlotMenuPanel from './SaxsHPLCPlotMenuPanel'
import SaxsSimplePlot from './SaxsSimplePlot'
import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import { getDownloadHDF5FramesURL } from '../../api/ispyb'

class SaxsHPLCSummaryPlot extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedAbscissa: null,
      isPlottedDataScaledToOne: false,
      isShowingI0Data: true,
      isShowingSum_IData: false,
      isShowingRgData: true,
      isShowingMassData: false,
      uvAbsorptionDataToShow: null,
      isShowingUvAbsorptionData: false,
      minFrameRange: null,
      maxFrameRange: null,
      minTimeRange: null,
      maxTimeRange: null,
      minVolumeRange: null,
      maxVolumeRange: null,
    }

    this.normalizeDataSerie = this.normalizeDataSerie.bind(this)
    this.divideValuesByMax = this.divideValuesByMax.bind(this)
    this.getMinAndMaxValues = this.getMinAndMaxValues.bind(this)
    this.onScaleButtonClicked = this.onScaleButtonClicked.bind(this)
    this.onI0ButtonClicked = this.onI0ButtonClicked.bind(this)
    this.onSum_IButtonClicked = this.onSum_IButtonClicked.bind(this)
    this.onUvAbsorptionButtonClicked = this.onUvAbsorptionButtonClicked.bind(this)
    this.onRgButtonClicked = this.onRgButtonClicked.bind(this)
    this.onMassButtonClicked = this.onMassButtonClicked.bind(this)
    this.onPlotPointClicked = this.onPlotPointClicked.bind(this)
    this.onFrameRangeButtonClicked = this.onFrameRangeButtonClicked.bind(this)
    this.onVolumeRangeButtonClicked = this.onVolumeRangeButtonClicked.bind(this)
    this.onTimeRangeButtonClicked = this.onTimeRangeButtonClicked.bind(this)
    this.setFrameRange = this.setFrameRange.bind(this)

    this.uvAbsorptionDataToShow = this.uvAbsorptionDataToShow.bind(this)
  }

  uvAbsorptionDataToShow(uvAbsorptionDataToShow) {
    this.setState({
      uvAbsorptionDataToShow: uvAbsorptionDataToShow,
    })
  }

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.setState({
      selectedAbscissa: 'frame',
      dataSeries: this.props.dataSeries.commonSeries,
    })
  }

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedAbscissa: 'frame',
      dataSeries: nextProps.dataSeries.commonSeries,
    })
  }

  setSelectedAbscissa(selected) {
    this.setState({
      selectedAbscissa: selected,
    })
  }

  render() {
    let ranges = {
      frameStep: null,
      volumeStep: null,
      timeStep: null,
      minFrameRange: null,
      maxFrameRange: null,
      minTimeRange: null,
      maxTimeRange: null,
      minVolumeRange: null,
      maxVolumeRange: null,
    }

    const commonDataseries = cloneDeep(Object.values(this.state.dataSeries))

    // create dataSeries displayed on the plot as filtered by the user
    let requiredForDisplayDataSeries = []
    commonDataseries.forEach(dataSerie => {
      if (
        (dataSerie.values.name === 'I0' && this.state.isShowingI0Data) ||
        (dataSerie.name === 'I0StdDev' && this.state.isShowingI0Data) ||
        (dataSerie.name === 'sum_I' && this.state.isShowingSum_IData) ||
        (dataSerie.name === 'sum_IStdDev' && this.state.isShowingSum_IData) ||
        (dataSerie.name === 'Rg' && this.state.isShowingRgData) ||
        (dataSerie.name === 'RgStdDev' && this.state.isShowingRgData) ||
        (dataSerie.name === 'Mass' && this.state.isShowingMassData) ||
        (dataSerie.name === 'MassStdDev' && this.state.isShowingMassData)
      ) {
        let xValues = this.applyAbcissaDataCorrection(dataSerie, ranges)
        dataSerie.updateXYValues(xValues, dataSerie.y)
        requiredForDisplayDataSeries.push(dataSerie)
      }
    })

    if (this.state.uvAbsorptionDataToShow && this.state.isShowingUvAbsorptionData) {
      const uvAbsorptionDataserie = cloneDeep(this.props.dataSeries.UvAbsorption[this.state.uvAbsorptionDataToShow])
      let xValues = this.applyAbcissaCorrectionForUvAbsorptionDataSeries(uvAbsorptionDataserie, ranges)
      uvAbsorptionDataserie.updateXYValues(xValues, uvAbsorptionDataserie.y)
      requiredForDisplayDataSeries.push(uvAbsorptionDataserie)
    }

    if (requiredForDisplayDataSeries && requiredForDisplayDataSeries instanceof Array) {
      if (this.state.isPlottedDataScaledToOne === true) {
        requiredForDisplayDataSeries.forEach(dataSerie => {
          if (!dataSerie.values.isAStdDevDataSerie) {
            let stdDevDataSerie = find(
              requiredForDisplayDataSeries,
              dataSerie2 => dataSerie2.name === dataSerie.name + 'StdDev'
            )
            this.normalizeDataSerie(dataSerie, stdDevDataSerie)
          }
        })
      }
      return (
        <div>
          <SaxsHPLCPlotMenuPanel
            buttons={[
              {
                label: 'I0',
                onClick: this.onI0ButtonClicked,
                color: find(commonDataseries, item => item.label === 'I0')
                  ? find(commonDataseries, item => item.label === 'I0').color
                  : '#000000',
                isButtonPressed: this.state.isShowingI0Data,
              },
              {
                label: 'Sum_I',
                onClick: this.onSum_IButtonClicked,
                color: find(commonDataseries, item => item.label === 'sum_I')
                  ? find(commonDataseries, item => item.label === 'sum_I').color
                  : '#000000',
                isButtonPressed: this.state.isShowingSum_IData,
              },
              {
                label: 'Rg',
                onClick: this.onRgButtonClicked,
                color: find(commonDataseries, item => item.label === 'Rg')
                  ? find(commonDataseries, item => item.label === 'Rg').color
                  : '#000000',
                isButtonPressed: this.state.isShowingRgData,
              },
              {
                label: 'Mass',
                onClick: this.onMassButtonClicked,
                color: find(commonDataseries, item => item.label === 'Mass')
                  ? find(commonDataseries, item => item.label === 'Mass').color
                  : '#000000',
                isButtonPressed: this.state.isShowingMassData,
              },
            ]}
            dropdown={{
              UvAbsorption: {
                label: 'UV Absorption',
                onClick: this.onUvAbsorptionButtonClicked,
                color: 'purple',
                isButtonPressed: this.state.isShowingUvAbsorptionData,

                dataseries: this.props.dataSeries.UvAbsorption,
                uvAbsorptionDataToShow: this.uvAbsorptionDataToShow,
              },
            }}
            scale={{
              label: 'Scale',
              onClick: this.onScaleButtonClicked,
              color: null,
              isButtonPressed: this.state.isPlottedDataScaledToOne,
            }}
          />

          {this.state.selectedAbscissa && (
            <SaxsSimplePlot
              dataSeries={requiredForDisplayDataSeries}
              divId={this.props.divId}
              selectedAbscissa={this.state.selectedAbscissa}
              onPlotPointClicked={this.onPlotPointClicked}
            />
          )}

          {/* The footer*/}
          <Grid fluid>
            <Row>
              <Col xs={12} sm={10}>
                <Form inline>
                  <FormGroup bsSize="small" controlId="rangeSelector">
                    <InputGroup bsSize="small" style={{ display: 'inline-table', verticalAlign: 'middle' }}>
                      <InputGroup.Button style={{ width: '100px' }}>
                        <Button
                          style={{ width: '100px' }}
                          onClick={() => {
                            this.setSelectedAbscissa('frame')
                          }}
                        >
                          Frame
                        </Button>
                      </InputGroup.Button>

                      <FormControl
                        id="frame-min"
                        type="number"
                        placeholder="start"
                        style={{ width: '80px' }}
                        onChange={event => this.setFrameRange(ranges, 'min', event.target.value)}
                        defaultValue={ranges.minFrameRange}
                        disabled={!(this.state.selectedAbscissa === 'frame')}
                      />
                      <FormControl
                        id="frame-max"
                        type="number"
                        placeholder="end"
                        style={{ width: '80px' }}
                        onChange={event => this.setFrameRange(ranges, 'max', event.target.value)}
                        defaultValue={ranges.maxFrameRange}
                        disabled={!(this.state.selectedAbscissa === 'frame')}
                      />
                      <InputGroup.Button style={{ width: 'auto' }}>
                        <Button
                          onClick={() => {
                            this.onFrameRangeButtonClicked()
                          }}
                          disabled={!(this.state.selectedAbscissa === 'frame')}
                        >
                          Go
                        </Button>
                      </InputGroup.Button>
                      <InputGroup.Button style={{ width: 'auto' }}>
                        <OverlayTrigger
                          placement="left"
                          overlay={<Tooltip> Download data for all displayed frames</Tooltip>}
                        >
                          <Button
                            bsSize="small"
                            href={getDownloadHDF5FramesURL(
                              this.props.user,
                              this.props.proposal,
                              this.props.experimentId,
                              this.state.minFrameRange,
                              this.state.maxFrameRange
                            )}
                            disabled={this.state.minFrameRange === null || this.state.maxFrameRange === null}
                          >
                            <Glyphicon glyph="download" /> Download
                          </Button>
                        </OverlayTrigger>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                </Form>
              </Col>
              <Col xs={12} sm={2}>
                <Button bsSize="small" onClick={this.props.onClearSelectionButtonClicked}>
                  Clear selection
                </Button>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={10}>
                <Form inline>
                  <FormGroup bsSize="small" controlId="rangeSelector">
                    <InputGroup bsSize="small" style={{ display: 'inline-table', verticalAlign: 'middle' }}>
                      <InputGroup.Button style={{ width: '100px' }}>
                        <Button
                          disabled={
                            !(
                              this.props.dataSeries.FrameTimePeriod !== null &&
                              this.props.dataSeries.FirstFrameTime !== null &&
                              this.props.dataSeries.UVtoSAXSoffset !== null &&
                              this.props.dataSeries.elutionFlux !== null
                            )
                          }
                          style={{ width: '100px' }}
                          onClick={() => {
                            this.setSelectedAbscissa('volume')
                          }}
                        >
                          Volume
                        </Button>
                      </InputGroup.Button>

                      <FormControl
                        id="volume-min"
                        step={Number(ranges.volumeStep)}
                        type="number"
                        placeholder="start"
                        style={{ width: '80px' }}
                        onChange={event => this.setVolumeRange(ranges, 'min', event.target.value)}
                        defaultValue={ranges.minVolumeRange}
                        disabled={!(this.state.selectedAbscissa === 'volume')}
                      />

                      <FormControl
                        id="volume-max"
                        step={ranges.volumeStep}
                        type="number"
                        placeholder="end"
                        style={{ width: '80px' }}
                        onChange={event => this.setVolumeRange(ranges, 'max', event.target.value)}
                        defaultValue={ranges.maxVolumeRange}
                        disabled={!(this.state.selectedAbscissa === 'volume')}
                      />
                      <InputGroup.Button style={{ width: 'auto' }}>
                        <Button
                          onClick={() => {
                            this.onVolumeRangeButtonClicked()
                          }}
                          disabled={!(this.state.selectedAbscissa === 'volume')}
                        >
                          Go
                        </Button>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                </Form>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={10}>
                <Form inline>
                  <FormGroup bsSize="small" controlId="rangeSelector">
                    <InputGroup bsSize="small" style={{ display: 'inline-table', verticalAlign: 'middle' }}>
                      <InputGroup.Button style={{ width: 'auto' }}>
                        <Button
                          disabled={
                            !(
                              this.props.dataSeries.FrameTimePeriod !== null &&
                              this.props.dataSeries.FirstFrameTime !== null &&
                              this.props.dataSeries.UVtoSAXSoffset !== null &&
                              this.props.dataSeries.elutionFlux !== null
                            )
                          }
                          style={{ width: '100px' }}
                          onClick={() => {
                            this.setSelectedAbscissa('time')
                          }}
                        >
                          Time
                        </Button>
                      </InputGroup.Button>

                      <FormControl
                        id="time-min"
                        step={ranges.timeStep}
                        type="number"
                        placeholder="start"
                        style={{ width: '80px' }}
                        onChange={event => this.setTimeRange(ranges, 'min', event.target.value)}
                        defaultValue={ranges.minTimeRange}
                        disabled={!(this.state.selectedAbscissa === 'time')}
                      />
                      <FormControl
                        id="time-max"
                        step={ranges.timeStep}
                        type="number"
                        placeholder="end"
                        style={{ width: '80px' }}
                        onChange={event => this.setTimeRange(ranges, 'max', event.target.value)}
                        defaultValue={ranges.maxTimeRange}
                        disabled={!(this.state.selectedAbscissa === 'time')}
                      />
                      <InputGroup.Button style={{ width: 'auto' }}>
                        <Button
                          onClick={() => {
                            this.onTimeRangeButtonClicked()
                          }}
                          disabled={!(this.state.selectedAbscissa === 'time')}
                        >
                          Go
                        </Button>
                      </InputGroup.Button>
                    </InputGroup>
                  </FormGroup>
                </Form>
              </Col>
            </Row>
          </Grid>
        </div>
      )
    }
    return null
  }

  applyAbcissaCorrectionForUvAbsorptionDataSeries(uvAbsorptionDataserie) {
    let xValues = []

    switch (this.state.selectedAbscissa) {
      case 'frame':
        for (let i = 0; i < uvAbsorptionDataserie.x.length; i++) {
          xValues[i] = uvAbsorptionDataserie.x[i]
        }

        return xValues

      case 'volume':
        for (let i = 0; i < uvAbsorptionDataserie.x.length; i++) {
          xValues[i] =
            (((uvAbsorptionDataserie.x[i] - this.props.dataSeries.UVtoSAXSoffset) *
              this.props.dataSeries.FrameTimePeriod +
              this.props.dataSeries.FirstFrameTime) *
              this.props.dataSeries.elutionFlux) /
            60
        }

        return xValues
      case 'time':
        for (let i = 0; i < uvAbsorptionDataserie.x.length; i++) {
          xValues[i] =
            (uvAbsorptionDataserie.x[i] - this.props.dataSeries.UVtoSAXSoffset) *
              this.props.dataSeries.FrameTimePeriod +
            this.props.dataSeries.FirstFrameTime
        }
        return xValues
    }

    return uvAbsorptionDataserie.x
  }

  applyAbcissaDataCorrection(dataSerie, ranges) {
    let xValues = []

    switch (this.state.selectedAbscissa) {
      case 'frame':
        for (let i = 0; i < dataSerie.x.length; i++) {
          xValues[i] = dataSerie.x[i]
        }

        ranges.frameStep = Number.parseFloat((xValues[1] - xValues[0]).toPrecision(4))
        ranges.minFrameRange = Math.min(...xValues)
        ranges.maxFrameRange = Math.max(...xValues)
        return xValues
      case 'volume':
        for (let i = 0; i < dataSerie.x.length; i++) {
          xValues[i] =
            ((dataSerie.x[i] * this.props.dataSeries.FrameTimePeriod + this.props.dataSeries.FirstFrameTime) *
              this.props.dataSeries.elutionFlux) /
            60
        }

        ranges.volumeStep = Number.parseFloat((xValues[1] - xValues[0]).toPrecision(4))
        ranges.minVolumeRange = Math.min(...xValues)
        ranges.maxVolumeRange = Math.max(...xValues)
        return xValues
      case 'time':
        //  Time (i)=i* FrameTimePeriod + FirstFrameTime

        for (let i = 0; i < dataSerie.x.length; i++) {
          xValues[i] = dataSerie.x[i] * this.props.dataSeries.FrameTimePeriod + this.props.dataSeries.FirstFrameTime
        }

        ranges.timeStep = Number.parseFloat((xValues[1] - xValues[0]).toPrecision(4))
        ranges.minTimeRange = Math.min(...xValues)
        ranges.maxTimeRange = Math.max(...xValues)

        return xValues
    }

    return dataSerie.x
  }

  setFrameRange(ranges, minOrMax, value) {
    if (minOrMax && value) {
      if (minOrMax === 'min') {
        this.setState({
          minFrameRange: Number(value),
        })
      }
      if (minOrMax === 'max') {
        this.setState({
          maxFrameRange: Number(value),
        })
      }
    }
  }

  onFrameRangeButtonClicked() {
    const start = document.getElementById('frame-min').value
    const end = document.getElementById('frame-max').value
    Plotly.relayout(this.props.divId, { 'xaxis.range': [start, end] })
  }

  onTimeRangeButtonClicked() {
    const start = document.getElementById('time-min').value
    const end = document.getElementById('time-max').value
    Plotly.relayout(this.props.divId, { 'xaxis.range': [start, end] })
  }

  onVolumeRangeButtonClicked() {
    const start = document.getElementById('volume-min').value
    const end = document.getElementById('volume-max').value
    Plotly.relayout(this.props.divId, { 'xaxis.range': [start, end] })
  }

  onScaleButtonClicked() {
    this.setState({ isPlottedDataScaledToOne: !this.state.isPlottedDataScaledToOne })
  }

  onI0ButtonClicked() {
    this.setState({ isShowingI0Data: !this.state.isShowingI0Data })
  }

  onSum_IButtonClicked() {
    this.setState({ isShowingSum_IData: !this.state.isShowingSum_IData })
  }

  onRgButtonClicked() {
    this.setState({ isShowingRgData: !this.state.isShowingRgData })
  }

  onMassButtonClicked() {
    this.setState({ isShowingMassData: !this.state.isShowingMassData })
  }

  onUvAbsorptionButtonClicked() {
    this.setState({ isShowingUvAbsorptionData: !this.state.isShowingUvAbsorptionData })
  }

  onPlotPointClicked(event) {
    let xValue = event.points[0].x

    let I0 = null
    let rg = null
    let mass = null

    event.points.forEach(point => {
      if (point.data) {
        if (point.data.name === 'I0') {
          let index = findIndex(point.data.x, x => x === xValue)
          I0 = point.data.y[index]
        }
        if (point.data.name === 'Rg') {
          let index = findIndex(point.data.x, x => x === xValue)
          rg = point.data.y[index]
        }
        if (point.data.name === 'Mass') {
          let index = findIndex(point.data.x, x => x === xValue)
          mass = point.data.y[index]
        }
      }
    })

    this.props.onPlotPointClicked(xValue, I0, rg, mass)
  }

  /**
   * Normalize a dataSerie to 1. Looks for the maximum value and then divide everything but that value
   * @param {DataSerie} dataSerie a serie of data.
   * @param {DataSerie} dataSerieStdDev corresponding serie of data which represent the standard deviation.
   */
  normalizeDataSerie = function (dataSerie, dataSerieStdDev) {
    let minMaxDataSerie = this.getMinAndMaxValues(dataSerie)
    let minMaxDataserieStdDev = this.getMinAndMaxValues(dataSerieStdDev)

    let max = Math.max(minMaxDataSerie.max, minMaxDataserieStdDev ? minMaxDataserieStdDev.max : 0)
    this.divideValuesByMax(dataSerie, max)
    this.divideValuesByMax(dataSerieStdDev, max)

    // this.ranges[multiPlotsData[i].label] = values;

    // return dataSerie;
  }

  /** Given a stat float[] and a max number it will divide each value by max **/
  divideValuesByMax = function (dataSerie, max) {
    if (dataSerie) {
      for (let j = 0; j < dataSerie.values.y.length; j++) {
        if (max !== 0) {
          dataSerie.values.y[j] = Number(dataSerie.values.y[j]) / max
        }
      }
    }
  }

  /** returns min and max value of a data serie
   * @param {DataSerie} dataSerie data serie object for one measurement
   * @param {DataSerie} dataSerie corresponding data serie errors associated the the measurement
   *
   */
  getMinAndMaxValues = function (dataSerie) {
    if (dataSerie) {
      let max = 0
      let min = dataSerie.values.y[0]
      for (let j = 0; j < dataSerie.values.y.length; j++) {
        if (Number(dataSerie.values.y[j]) > max) {
          max = Number(dataSerie.values.y[j])
        }
        if (Number(dataSerie.values.y[j]) < min) {
          min = Number(dataSerie.values.y[j])
        }
      }
      return {
        max: Number(max),
        min: Number(min),
      }
    }
  }
}

export default SaxsHPLCSummaryPlot

SaxsHPLCSummaryPlot.propTypes = {
  /* div identifier containing the plot */
  divId: PropTypes.string,
  /* the data to be displayed */
  graph: PropTypes.object,
}
